import React from 'react';

const AudioEqualizer = ({ className = '', barCount = 4 }) => {
    const bars = Array.from({ length: barCount }, (_, index) => (
        <div key={index} className="keduall-custom-accordion-equalizer-bar"></div>
    ));

    return (
        <div className={`keduall-custom-accordion-equalizer ${className}`}>
            {bars}
        </div>
    );
};

export default AudioEqualizer;
